angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/login/login.html',
    '<!-- Logo -->\n' +
    '<update-title title="Log In | PEforHire.com"></update-title>\n' +
    '<update-meta name="description" content="Log into P.E. For Hire to access your dashboard and manage your user profile. View your projects, requests and proposals."></update-meta>\n' +
    '<header class="logo-bar">\n' +
    '    <div class="container-fluid">\n' +
    '        <a href="" ui-sref="index" class="logo">\n' +
    '            <svg class="symbol" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.2 70.7">\n' +
    '                <polygon class="pol-a white" points="44.4 43.3 44.4 43.3 30.6 51.3 16.8 43.3 16.8 43.3 0 53 30.6 70.7 61.2 53"/>\n' +
    '                <polygon class="pol-b white" points="30.6 0 30.6 19.4 44.4 27.4 44.4 43.3 61.2 53 61.2 17.7"/>\n' +
    '                <polygon class="pol-c white" points="16.8 27.4 30.6 19.4 30.6 0 0 17.7 0 53 16.8 43.3"/>\n' +
    '            </svg>\n' +
    '            <div class="white">\n' +
    '                <strong class="white">pe</strong><span>4h</span>\n' +
    '            </div>\n' +
    '        </a>\n' +
    '    </div>\n' +
    '</header>\n' +
    '\n' +
    '<!-- Top Display -->\n' +
    '<section class="content access">\n' +
    '    <div class="container-fluid gradient-blu">\n' +
    '        <!-- Log in -->\n' +
    '        <form method="get" name="loginForm" ng-submit="">\n' +
    '            <div id="log-in">\n' +
    '                <h2>Log in</h2>\n' +
    '                <div class="box">\n' +
    '                    <div class="form-group">\n' +
    '                        <input type="email" id="Username" required ng-model="mail">\n' +
    '                        <label for="Username">Email</label>\n' +
    '                        <footer></footer>\n' +
    '                    </div>\n' +
    '                    <div class="form-group">\n' +
    '                        <input type="password" id="Password" required ng-model="password">\n' +
    '                        <label for="Password">Password</label>\n' +
    '                        <footer></footer>\n' +
    '                    </div>\n' +
    '                    <div class="form-group">\n' +
    '                        <button class="btn btn-primary btn-lg btn-block" ng-click="login()" ng-disabled="!loginForm.$valid">Log in</button>\n' +
    '                    </div>\n' +
    '                    <div class="text-right">\n' +
    '                        <a class="passwd" href="" ui-sref="forgotPassword">Forgot Password?</a>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </form>\n' +
    '        <span id="link-create">\n' +
    '            <a href="" ui-sref="first-step" class="pe-license">Sign up</a>\n' +
    '        </span>\n' +
    '    </div>\n' +
    '</section>\n' +
    '');
}]);
